import { indentMore } from '@codemirror/commands';
import { StateCommand } from '@codemirror/state';

/**
 * Inserts two spaces instead of a tab character. If something is selected,
 * the entire selection gets indented.
 */
export const indentWithSpaces: StateCommand = ({ state, dispatch }) => {
  if (state.selection.ranges.some((r) => !r.empty)) {
    return indentMore({ state, dispatch });
  }
  dispatch(
    state.update(state.replaceSelection('  '), {
      scrollIntoView: true,
      userEvent: 'input',
    }),
  );
  return true;
};
